import { PaymentErrorCodes } from '@app/types/monolith/PaymentErrorCodes';
import { useEffect, useState } from 'react';
import { getPaymentErrorMessage } from './paymentErrorLookup';
import { ErrorMessage } from './types';

export const usePaymentRedirectError = () => {
  const [error, setError] = useState<ErrorMessage>();

  useEffect(() => {
    const { href } = global.window.location;

    let url: URL | undefined;
    try {
      url = new URL(href);
    } catch {
      // oh hail the linter
      url = undefined;
    }

    if (url) {
      const code = url.searchParams.get('error_code') || '';

      switch (code) {
        case PaymentErrorCodes.CHARGE_FAILED:
          setError(getPaymentErrorMessage({ code }));
          break;
        case PaymentErrorCodes.CHARGE_FAILED_RETRY_ALLOWED:
          setError(getPaymentErrorMessage({ code }));
          break;
        case PaymentErrorCodes.SERVER_ERROR:
          setError(getPaymentErrorMessage({ code }));
          break;
        default:
          // We intentionally do not parse any other codes as the Stripe
          // return URL logic will only ever return the above codes.
          //
          // See <redbubble>/app/controllers/stripe/payment_intents_verify_controller.rb.
          //
          // If the code does not match the above codes, we assume some
          // nefarious actor has set it and isn't useful to display.
          break;
      }
    }
  }, []);

  return { error };
};
